export const FLASH_MESSAGES = {
	sourceCodeIsRequired: 'you need some code to save',
	couldNotSaveCode: 'Wait! Your changes are not saved. Please try again.',
	couldNotCompileCode: 'Sorry! Something went wrong.',
	smtWentWrong: 'Sorry! Something went wrong.',
};
